import React, { Component } from "react";
import LoginForm from "../../components/LoginForm/LoginForm";

class LoginRoute extends Component {
  static defaultProps = {
    location: {},
    history: {
      push: () => {},
    },
  };

  handleLoginSuccess = () => {
    const { location, history } = this.props;
    const destination = (location.state || {}).from || "/";
    history.push(destination);
  };

  render() {
    return (
     <div class="min-h-screen bg-gray-400 flex justify-center items-center">
        <div class="py-12 px-12 bg-white rounded-2xl shadow-xl z-20">
          <LoginForm onLoginSuccess={this.handleLoginSuccess} />
        </div>
    </div>
    );
  }
}

export default LoginRoute;
